// RevenueCat Configuration for Web SDK
export const REVENUECAT_CONFIG = {
  // Single API key - can be either production or sandbox key depending on environment
  // Get these from https://app.revenuecat.com/
  publicApiKey: process.env.REACT_APP_REVENUECAT_API_KEY || 'your_api_key_here',
  
  // Environment settings
  environment: process.env.REACT_APP_ENV as 'development' | 'production' || 'development',
  
  // User identification settings
  allowSharingStoreAccount: false,
  
  // Debug settings (only for development)
  debugLogsEnabled: process.env.REACT_APP_ENV === 'development',
  
  // Product identifiers - replace with your actual product IDs from RevenueCat
  products: {
    // Pro subscription
    pro_weekly: '$rc_weekly',
    // Legacy products (keeping for backward compatibility)
    monthly: 'visa_ai_monthly',
    annual: 'visa_ai_annual',
    premium: 'visa_ai_premium',
  },
  
  // Offering identifiers
  offerings: {
    standard_pro: 'standart_pro',
  },
  
  // Entitlement identifiers - replace with your actual entitlement IDs
  entitlements: {
    pro: 'thevisaai_pro',
    premium: 'premium',
  },
} as const;

export type RevenueCatProduct = keyof typeof REVENUECAT_CONFIG.products;
export type RevenueCatEntitlement = keyof typeof REVENUECAT_CONFIG.entitlements; 